import * as React from "react";
import {cx} from "emotion";

import "./calendar.scss";

import {cs}                      from "@Common/react/chain-services";
import * as dateObj              from "@Common/utils/date-object";
import {sameDate, getMonthWeeks} from "@Common/utils/date-object";

export const Calendar = ({startDate, endDate, monthYear, isDisabled, onSelect}) => cs(
    () => (
        <div
            className="calendar-0ml"
        >
            <div className="header-row">
                {weekdays.map((wd) => (
                    <div
                        key={wd}
                    >
                        <label>
                            {wd}
                        </label>
                    </div>
                ))}
            </div>
            <div className="dates">
                {getMonthWeeks({month: monthYear.month, year: monthYear.year})
                    .map((weekDays) => (
                        Week({weekDays, monthYear, onSelect, isDisabled, startDate, endDate})
                    ))
                }
            </div>

        </div>
    ),
);

const Week = ({weekDays, monthYear, onSelect, isDisabled, startDate, endDate}) => (
    <div
        className="date-row"
        key={`${weekDays[0].month}-${weekDays[0].day}`}
    >
        {weekDays.map((date) => {
            const disabled = isDisabled?.(date) || false;
            return (
                <button
                    key={date.month + " " + date.day}
                    className={cx("date", {
                        selected: sameDate(date, startDate) || sameDate(date, endDate),
                        disabled,
                        grayedOut: date.month != monthYear.month,
                        ...(
                            startDate != null &&
                            endDate != null
                        ) && {
                            inSelectedRange: (
                                dateObj.gt(date, startDate) &&
                                dateObj.lt(date, endDate)
                            ),
                            openingEndpoint: (
                                !sameDate(startDate, endDate) &&
                                sameDate(date, startDate)
                            ),
                            closingEndpoint: (
                                !sameDate(startDate, endDate) &&
                                sameDate(date, endDate)
                            ),
                        },
                    })}
                    onMouseDown={() => !disabled && onSelect(date)}
                    xd-qa-type="button"
                    xd-qa-name={"date " + date.month + "/" + date.day + "/" + date.year}
                >
                    {date.day}
                </button>
            );
        })}
    </div>
);

const weekdays = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
];
